// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRewritesTunnelPath"] = "/monitoring";globalThis["SENTRY_RELEASE"] = {"id":"9d0aa24a4926e7a9af473995ece4a47cde93fb72"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "/storefront/9d0aa24a4926e7a9af473995ece4a47cde93fb72";import * as Sentry from '@sentry/nextjs';
import getConfig from 'next/config';

const envVars = getConfig().publicRuntimeConfig;

Sentry.init({
  dsn: envVars.SENTRY_DSN || '',
  release: envVars.SENTRY_RELEASE || '',
  tracesSampleRate: 0.1,
  debug: false,
  integrations: [
    Sentry.thirdPartyErrorFilterIntegration({
      filterKeys: ['storefront'],
      behaviour: 'drop-error-if-exclusively-contains-third-party-frames',
    }),
  ],
});
